export const MINIMUM_SEARCH_LENGTH = 3;

export const hasActiveSearch = (query) => {
  return Boolean(
    query.q ||
    (query.types && query.types.length > 0) ||
    (query.gradeIds && query.gradeIds.length > 0) ||
    (query.scopeIds && query.scopeIds.length > 0) ||
    (query.subjectIds && query.subjectIds.length > 0) ||
    (query.contentCategoryTypes && query.contentCategoryTypes.length > 0)
  );
};

export const isValidSearchLength = (query) => {
  return query.length === 0 || query.length >= MINIMUM_SEARCH_LENGTH;
};

export const isQueryTooShort = (query) => {
  return query.length > 0 && query.length < MINIMUM_SEARCH_LENGTH;
};
